import React from 'react';
import paths from '../blogs/blogPostIcons.json';

export default function BlogPostIcon({ name, size = 20, className = '' }) {
  const path = paths[name];
  if (!path) return null;
  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="none"
      height={size}
      viewBox="0 0 24 24"
      width={size}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <path d={path} />
    </svg>
  );
}
